import firestore, { Timestamp } from 'firebase/firestore';
import { Basket } from './Basket';
import { GroupMemberStatus } from './groupMemberStatus';
import { GroupOrderIds } from './GroupOrder';

export class Commandes {
    orderId?: string;

    fermeId?: string;

    clientId?: string;

    groupId?: string;

    pickupTimeSlot?: string;

    pickupDay?: string;

    createdAt?: Timestamp;

    originalOrder?: boolean;

    paymentSuccessful?: boolean;

    orderCompleted?: boolean;

    baskets?: Basket[];

    groupMemberOrderIds?: GroupOrderIds[];

    groupMemberOrderStatuses?: GroupMemberStatus[];

    totalPrix?: number;

    constructor({
        orderId,
        fermeId,
        clientId,
        groupId,
        pickupTimeSlot,
        pickupDay,
        createdAt,
        originalOrder,
        paymentSuccessful,
        orderCompleted,
        baskets,
        groupMemberOrderIds,
        groupMemberOrderStatuses,
        totalPrix
    }: {
        orderId?: string;
        fermeId?: string;
        clientId?: string;
        groupId?: string;
        pickupTimeSlot?: string;
        pickupDay?: string;
        createdAt?: Timestamp;
        originalOrder?: boolean;
        paymentSuccessful?: boolean;
        orderCompleted?: boolean;
        baskets?: Basket[];
        groupMemberOrderIds?: GroupOrderIds[];
        groupMemberOrderStatuses: GroupMemberStatus[];
        totalPrix: number;
    }) {
        this.orderId = orderId;
        this.fermeId = fermeId;
        this.clientId = clientId;
        this.groupId = groupId;
        this.pickupTimeSlot = pickupTimeSlot;
        this.pickupDay = pickupDay;
        this.createdAt = createdAt;
        this.originalOrder = originalOrder;
        this.paymentSuccessful = paymentSuccessful;
        this.orderCompleted = orderCompleted;
        this.baskets = baskets;
        this.groupMemberOrderIds = groupMemberOrderIds;
        this.groupMemberOrderStatuses = groupMemberOrderStatuses;
        this.totalPrix = totalPrix;
    }
}

export const CommandesConverter: firestore.FirestoreDataConverter<Commandes> = {
    toFirestore(commandes) {
        return {
            orderId: commandes.orderId,
            fermeId: commandes.fermeId,
            clientId: commandes.clientId,
            groupId: commandes.groupId,
            pickupTimeSlot: commandes.pickupTimeSlot,
            pickupDay: commandes.pickupDay,
            createdAt: commandes.createdAt,
            originalOrder: commandes.originalOrder,
            paymentSuccessful: commandes.paymentSuccessful,
            orderCompleted: commandes.orderCompleted,
            baskets: commandes.baskets,
            groupMemberOrderIds: commandes.groupMemberOrderIds,
            groupMemberOrderStatuses: commandes.groupMemberOrderStatuses,
            totalPrix: commandes.totalPrix
        };
    },
    fromFirestore(snapshot, options): Commandes {
        const data = snapshot.data(options);
        return new Commandes({
            orderId: data.orderId,
            fermeId: data.fermeId,
            clientId: data.clientId,
            groupId: data.groupId,
            pickupTimeSlot: data.pickupTimeSlot,
            pickupDay: data.pickupDay,
            createdAt: data.createdAt,
            originalOrder: data.originalOrder,
            paymentSuccessful: data.paymentSuccessful,
            orderCompleted: data.orderCompleted,
            baskets: data.baskets,
            groupMemberOrderIds: data.groupMemberOrderIds,
            groupMemberOrderStatuses: data.groupMemberOrderStatuses,
            totalPrix: data.totalPrix
        });
    }
};
